export default __webpack_public_path__ + "static/4-064e0c39d4f8b8f113764655509b66a2.jpeg";